<p>sales-order-detail works!</p>
